import { FunctionComponent, useContext } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material'
import { ContentCopy } from '@mui/icons-material'
import { UserNotificationsContext } from '../../../context/user-notifications/user-notifications'

export const ShareLinkDialog: FunctionComponent<{
  link: string,
  open: boolean,
  closeHandler: () => void,
  isPublic?: boolean,
}> = ({
  link,
  open,
  closeHandler,
  isPublic = false
}) => {

    const userNotificationsContext = useContext(UserNotificationsContext)

    const copyHandler = (textToCopy: string) => {
      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          userNotificationsContext.openSnackbar({ open: true, message: 'Copied' });
        })
        .catch(err => console.log(err))
    }


    return (
      <Dialog open={open} onClose={closeHandler} >
        <Box sx={{ p: 4 }}>
          <DialogTitle sx={{ pt: 0, pl: 0, pr: 0 }}>
            Share this Link
          </DialogTitle>
          <DialogContent sx={{ pt: 0, pl: 0, pr: 0 }}>
            <Box sx={{ borderWidth: '1px', borderStyle: 'solid', borderColor: 'lightGrey.main', borderRadius: '10px', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1, pl: 2, pr: 2, pt: 1, pb: 1 }}>
              <Typography noWrap
                sx={{
                  flexGrow: 1,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }} variant='body1'>
                {link}
              </Typography>
              <IconButton onClick={() => copyHandler(link)}><ContentCopy sx={{ color: 'text.secondary' }} /></IconButton>
            </Box>
            {!isPublic && <Typography variant='subtitle1' sx={{ color: 'text.secondary', pt: 1, pl: 1 }}>This link will only be valid for 24 hours</Typography>}
          </DialogContent>
          <DialogActions sx={{ p: 0 }}>
            <Button variant='text' onClick={closeHandler}><Typography sx={{ p: 0.5 }}>Close</Typography></Button>
          </DialogActions>
        </Box>
      </Dialog>
    )
  }